import React from "react";

export function PageHeader({ title, subtitle, eyebrow, children }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-6 mb-6 border-b border-slate-200"
      data-testid="page-header"
    >
      <div>
        {eyebrow && (
          <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-amber-700 mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-sm text-slate-600 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {children && <div className="flex items-center gap-3">{children}</div>}
    </div>
  );
}

export function KpiCard({ label, value, unit, delta, accent = "slate", testid }) {
  const accentColor =
    {
      slate: "text-slate-900",
      amber: "text-amber-700",
      green: "text-emerald-700",
      red: "text-red-600",
    }[accent] || "text-slate-900";

  return (
    <div
      data-testid={testid}
      className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden"
    >
      <div className="absolute left-0 top-0 h-full w-1 kpi-rule" />
      <div className="text-[11px] font-semibold uppercase tracking-[0.15em] text-slate-500">
        {label}
      </div>
      <div className={`mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tighter ${accentColor}`}>
        {value}
      </div>
      <div className="flex items-baseline justify-between mt-2">
        {unit && <span className="text-xs text-slate-500">{unit}</span>}
        {delta && (
          <span className="text-xs font-medium text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded">
            {delta}
          </span>
        )}
      </div>
    </div>
  );
}

export function SectionCard({ title, description, children, action, className = "" }) {
  return (
    <div
      className={`bg-white border border-slate-200 rounded-lg p-5 md:p-6 shadow-sm ${className}`}
      data-testid="section-card"
    >
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <h3 className="font-display text-base sm:text-lg font-semibold text-slate-900 tracking-tight">
            {title}
          </h3>
          {description && (
            <p className="text-xs text-slate-500 mt-1">{description}</p>
          )}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}

export function RagBadge({ level }) {
  const map = {
    green: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Low" },
    amber: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", label: "Medium" },
    red: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "High" },
  };
  const s = map[level] || map.green;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold ${s.bg} ${s.text} border ${s.border}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${level === "green" ? "bg-emerald-500" : level === "amber" ? "bg-amber-500" : "bg-red-500"}`} />
      {s.label}
    </span>
  );
}
